module.exports = __webpack_public_path__ + "img/settings.5c080794.svg";